export const isLocalhost = () => window.location.hostname.includes('localhost');
export const getHostnameWithoutAppName = () => window.location.hostname.split('.').slice(1).join('.');
export const getServerHost = () => {
    return `/app`;
};
export const isProduction = () => window['autentiConfig'] && window['autentiConfig'].env === 'production';
export const isDev = () => window['autentiConfig'] && window['autentiConfig'].env === 'development';
export const isRequiredAuthOnSign = () => window.location.href.indexOf('?id') > -1;
export const isRequiredAuthOnAccounts = () => window.location.href.indexOf('/settings') > -1;
export const isSignApp = () => process.env.REACT_APP_NODE_ENV === 'sign';
export const isDocsApp = () => process.env.REACT_APP_NODE_ENV === 'docs';
export const isAccountApp = () => process.env.REACT_APP_NODE_ENV === 'accounts';
export const getSigningProcessIdFromUrl = () => {
    const splitedPathname = window.location.pathname.split('/');
    return splitedPathname && splitedPathname[1];
};
